import React from "react";
import moment from "moment";

const DateSeparator = ({ date }) => {
  const today = moment().startOf("day");
  const yesterday = moment().subtract(1, "days").startOf("day");
  const messageDate = moment(date).startOf("day");
  const lastSunday = moment().startOf("week"); // Sunday is start of week in moment

  let displayText;

  if (messageDate.isSame(today, "day")) {
    displayText = "Today";
  } else if (messageDate.isSame(yesterday, "day")) {
    displayText = "Yesterday";
  } else if (messageDate.isAfter(lastSunday)) {
    // If it's after last Sunday but not today or yesterday, show day name
    displayText = messageDate.format("dddd"); // e.g., "Monday", "Tuesday", etc.
  } else {
    // For older dates, show the date
    displayText = messageDate.format("MMMM D, YYYY"); // e.g., "May 10, 2025"
  }

  return (
    <div className="flex justify-center my-2 top-0  py-2 z-10">
      <div className="bg-slate-900 max-w-[120px] w-full text-center backdrop-blur-sm text-white text-xs font-medium px-4 py-1 rounded-full">
        {displayText}
      </div>
    </div>
  );
};

export default DateSeparator;
